import React, { useEffect } from "react";
import ProgressCircle from "../../../components/ProgressCircle.tsx";
import { useJournalContext } from "../../../contexts/journal.tsx";
import FormatDate from "../../../models/helpers/formatDate.ts";
import { JournalSearchParam } from "../../../models/searchParams/journalSearchParam.ts";

export const JournalDays = () => {
    const {
        days,
        searchParam,
        setSearchParam
    } = useJournalContext();

    const handleDayClick = (dateTime: Date) => {
        setSearchParam((prevData: JournalSearchParam) => ({ ...prevData, dateTime: dateTime }));
    }

    const getDayName = (date: Date) => {
        return date.toLocaleDateString('en-US', { weekday: 'short' }); // You can change 'en-US' to your preferred locale
    };

    useEffect(() => {
        const selectedDay = days.find(day => FormatDate(day.dateTime) === FormatDate(searchParam.dateTime));

        if (selectedDay) {
            const currentDayElement = document.getElementById(FormatDate(selectedDay.dateTime)!);
            if (currentDayElement) {
                currentDayElement.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            }
        }
    }, [days, searchParam.dateTime]);

    return (
        <div
            className="container text-center overflow-x-scroll maxw-1920"
            style={{
                overflow: "x-scroll",
                msOverflowStyle: "none",
                scrollbarWidth: "none",
                display: "flex",
                flexDirection: "row",
                scrollSnapType: "x mandatory",
                scrollBehavior: "smooth",
            }}>
            <style>
                {`
                    .container::-webkit-scrollbar {
                        display: none; /* For Chrome, Safari, and Opera */
                    }
                `}
            </style>
            <div className="row d-flex flex-row flex-nowrap" >
                {days.map((day, index) => {
                    return (
                        <div
                            key={FormatDate(day.dateTime)}
                            id={FormatDate(day.dateTime)}
                            className={`col my-auto py-2 ${FormatDate(day.dateTime) == FormatDate(searchParam.dateTime) ? "card" : ""}`}
                            onClick={() => handleDayClick(day.dateTime)}
                        >
                            <h6 className="mx-auto" style={{ width: "fit-content" }}>{getDayName(day.dateTime)}</h6>
                            <ProgressCircle
                                percent={day.percent}
                                text={String(day.dateTime.getDate()).padStart(2, '0')}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
}